export const summarizeDeadlines = (items = []) => {
  const counts = new Map();
  items.forEach((item) => {
    const raw = item.serviceDeadline || item.exchangeDeadline;
    const date = raw?.toDate ? raw.toDate() : new Date(raw || '');
    const value = raw && Number.isFinite(date.getTime()) ? date.toISOString() : '';
    counts.set(value, (counts.get(value) || 0) + 1);
  });
  const groups = [...counts].map(([value, count]) => ({ value, count }));
  const common = groups.length === 1 ? groups[0].value : '';
  return { groups, mixed: groups.length > 1, hasDeadline: groups.some((g) => g.value),
    input: common ? new Date(Date.parse(common) + 8 * 3600000).toISOString().slice(0, 16) : '' };
};
